<template>
  <div>
    <TourSearchableList v-bind="$attrs" :base-filters="props.baseFilters" :options="props.options">
      <template #columns="{ tour }">
        <div v-if="tour && Number.isInteger(tour.associated_parks_count) && Number.isInteger(tour.parks_count)" class="tw:flex tw:flex-col tw:md:flex-row tw:items-end tw:md:items-center tw:gap-1 tw:md:gap-3 tw:px-4 tw:py-3 tw:shrink-0">
          <div v-if="tour?.disallow_brand_parks" class="tw:flex tw:items-center tw:gap-2 tw:text-zinc-500 tw:text-sm tw:max-w-44">
            <PackageCheckIcon class="tw:size-4 tw:shrink-0 tw:mt-0.5" />
            <span>
              {{ $t('Event park automatically applied') }}
            </span>
          </div>
          <span
            v-else
            class="tw:whitespace-nowrap tw:text-sm tw:md:text-base"
            :class="totalParks(tour) === 0 ? 'tw:text-red-500' : 'tw:text-zinc-900'"
          >
            {{ $t('park selected', { count: totalParks(tour) }, totalParks(tour)) }}
          </span>
          <Button variant="outline" size="sm" @click="editTourParks(tour)">
            <SettingsIcon class="tw:size-4" />
            {{ $t('Manage') }}
          </Button>
        </div>
      </template>
    </TourSearchableList>

    <ParksSelector
      :tour="parksSelectorTour"
      :parks-available="props.parks"
      :parkableUrl="props.parkableUrl"
      :filters="props.baseFilters"
      @close="parksSelectorTour = null"
      @change="emitEvent('refresh-tours-list')"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import TourSearchableList from "@/components/Tour/TourSearchableList.vue";
import ParksSelector from "@/components/park/ParksSelector.vue";
import { Button } from "@/shadcn/components/ui/button";
import { PackageCheckIcon, SettingsIcon } from "@lucide/vue";
import { emit as emitEvent } from "@/eventBus.js";

defineOptions({ inheritAttrs: false })

const props = defineProps({
  parkableUrl: {
    type: String,
    default: null,
  },
  parks: {
    type: Array,
    default: () => [],
  },
  baseFilters: {
    type: Object,
    default: () => ({}),
  },
  options: {
    type: Object,
    default: () => ({}),
  },
})

const parksSelectorTour = ref(null);

const totalParks = (tour) => (tour.associated_parks_count ?? 0) + (tour.parks_count ?? 0)

const editTourParks = (tour) => {
  parksSelectorTour.value = tour;
}
</script>
